import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type EmbedRuntime = {
  apiBase?: string
  token?: string
}

function getEmbedRuntime(): EmbedRuntime | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as any).__TOTEMIUM_EMBED__
}

export function getApiBase() {
  const embed = getEmbedRuntime()
  if (embed?.apiBase) return embed.apiBase
  // Nginx will proxy /api/* to FastAPI
  return '/api'
}

/**
 * URL publique du webhook Meta (WhatsApp Cloud API) — même origine que l'app, Nginx proxy vers le service Node.
 * À copier dans Meta App Dashboard → WhatsApp → Configuration.
 */
export function getWhatsAppMetaWebhookCallbackUrl(): string {
  if (typeof window === 'undefined') return ''
  return `${window.location.origin}/webhook/meta`
}

export function getToken(): string | null {
  const embed = getEmbedRuntime()
  if (embed?.token) return embed.token
  try {
    return localStorage.getItem('access_token')
  } catch {
    return null
  }
}

export function setTokens(access: string, refresh?: string | null) {
  try {
    localStorage.setItem('access_token', access)
    if (refresh) localStorage.setItem('refresh_token', refresh)
  } catch {
    // Ignore storage errors in environments without localStorage access
  }
}

export function clearTokens() {
  try {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  } catch {
    // ignore
  }
}

export function setThemeClass() {
  const root = document.documentElement
  root.classList.add('dark')
}
